<template>
    <div class="rd">
        <div class="pagina">
            <div class="inlog-wrap">
                <form class="paneel inlog-kaart" novalidate @submit.prevent="savePassword">
                    <img src="/x-cube-logo.png" alt="X-Cube" class="inlog-logo" />
                    <h1>Reset password</h1>
                    <p class="muted" style="margin:0 0 8px">Choose a new password for your account.</p>

                    <div class="veld">
                        <label for="rp-pw">New password</label>
                        <input
                            id="rp-pw"
                            v-model="model.password"
                            type="password"
                            autocomplete="new-password"
                            minlength="5"
                            maxlength="32"
                            @input="error = ''"
                        />
                    </div>
                    <div class="veld">
                        <label for="rp-pw2">Confirm password</label>
                        <input
                            id="rp-pw2"
                            v-model="model.confirmPassword"
                            type="password"
                            autocomplete="new-password"
                            minlength="5"
                            maxlength="32"
                            :aria-invalid="!!error"
                            @input="error = ''"
                        />
                        <span class="fout">{{ error }}</span>
                    </div>

                    <button class="btn btn-pink" type="submit" style="width:100%" :disabled="loading">
                        {{ loading ? "Saving…" : "Reset password" }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { Message } from "element-ui";
import * as Sentry from "@sentry/vue";
import { useRoute, useRouter } from "vue-router/composables";
import { request } from "../../api/rest";

const router = useRouter();
const route = useRoute();

const token = route.params.token;
const loading = ref(false);
const error = ref("");
const model = ref({
    password: "",
    confirmPassword: "",
});

const savePassword = async () => {
    if (model.value.password.length < 5) {
        error.value = "Use at least 5 characters.";
        return;
    }
    if (model.value.password !== model.value.confirmPassword) {
        error.value = "Passwords do not match";
        return;
    }
    try {
        loading.value = true;
        const result = await request(
            "/auth/reset-password",
            { method: "POST" },
            {
                code: token,
                password: model.value.password,
                passwordConfirmation: model.value.password,
            },
        );

        if (result.status >= 200 && result.status < 299) {
            const res = await result.json();
            const jwt = res.jwt;
            Message.success("Password has been changed");
            router.push({ name: "booking", params: { jwt } });
        } else {
            Message.error("Could not change password, please contact support.");
        }
    } catch (e) {
        console.error("Reset password error:", e);
        Message.error("An error occurred while resetting your password.");
        Sentry.captureException(e);
    } finally {
        loading.value = false;
    }
};
</script>
